/**
 * PORTAL-169: Potter's-specific wording — the "provider_pay" payment type is
 * labeled "Clinic Pay" when the pharmacy's `use_clinic_pay_label` flag is set.
 * Display-only; the underlying enum value and API payloads never change.
 */
export function providerPayLabel(useClinicPay: boolean | undefined): string {
  return useClinicPay ? 'Clinic Pay' : 'Provider Pay'
}
